// @flow

import * as React from 'react';
import ReactAI from 'react-appinsights';
import NumberInput from "./NumberInput";
import OptionManager from "../common/OptionManager";

import type {ComponentMeta, UnmountHandler} from "../common/CommonTypes";
import CalculationSectionHeader from "./CalculationSectionHeader";

type Props = {
    optionManager: OptionManager,

    onChange: (event: SyntheticEvent<>) => void,
    onBlur: (event: SyntheticEvent<>) => void,
    onUnmount: UnmountHandler,

    coatingBefore: number,

    distanceReceiverFillingKm: number,
    distanceReceiverCleanAsphaltKm: number,
    distanceReceiverPollutedAsphaltKm: number,
    distanceReceiverOldTubesKm: number,
    distanceFillingKm: number,
    distanceAsphaltKm: number,
    
    distanceReceiverFillingKmMeta: ComponentMeta,
    distanceReceiverCleanAsphaltKmMeta: ComponentMeta,
    distanceReceiverPollutedAsphaltKmMeta: ComponentMeta,
    distanceReceiverOldTubesKmMeta: ComponentMeta,
    distanceFillingKmMeta: ComponentMeta,
    distanceAsphaltKmMeta: ComponentMeta,

    phaseNr: number,

};

class CalculationDistancesInput extends React.Component<Props> {

    render() {

        const optionManager = this.props.optionManager;

        const onChange = this.props.onChange;
        const onBlur = this.props.onBlur;
        const onUnmount = this.props.onUnmount;

        const coatingBefore = this.props.coatingBefore;

        const distanceReceiverFillingKm = this.props.distanceReceiverFillingKm;
        const distanceReceiverCleanAsphaltKm = this.props.distanceReceiverCleanAsphaltKm;
        // const distanceReceiverPollutedAsphaltKm = this.props.distanceReceiverPollutedAsphaltKm;
        const distanceReceiverOldTubesKm = this.props.distanceReceiverOldTubesKm;
        const distanceFillingKm = this.props.distanceFillingKm;


        return (

            <div className="calculation-distances input-section">

                <CalculationSectionHeader text="Avstånd" id={ `distances-${this.props.phaseNr}` } />


                <div className="input-section-content">
                    <div className="row">
    
                        <NumberInput    htmlName="distanceReceiverFillingKm"
                                        onChange={onChange}
                                        onBlur={onBlur}
                                        onUnmount={onUnmount}
                                        labelText="Avstånd till mottagare av fyllnadsmassor (km)"
                                        phaseNr={this.props.phaseNr}
                                        extraClassFormGroup="col-sm-6"
                                        value={distanceReceiverFillingKm}
                                        meta={this.props.distanceReceiverFillingKmMeta}
                                        min={0} />
    
                        <NumberInput    htmlName="distanceReceiverOldTubesKm"
                                        onChange={onChange}
                                        onBlur={onBlur}
                                        onUnmount={onUnmount}
                                        labelText="Avstånd till mottagare av befintliga rör och rörspill (km)"
                                        phaseNr={this.props.phaseNr}
                                        extraClassFormGroup="col-sm-6"
                                        value={distanceReceiverOldTubesKm}
                                        meta={this.props.distanceReceiverOldTubesKmMeta}
                                        min={0} />
    
    
                    </div>
    
                    { coatingBefore === optionManager.ids.COATING_ASPHALT &&
                    <div className="row">
                        <NumberInput    htmlName="distanceReceiverCleanAsphaltKm"
                                        onChange={onChange}
                                        onBlur={onBlur}
                                        onUnmount={onUnmount}
                                        labelText="Avstånd till mottagare av asfalt (km)"
                                        phaseNr={this.props.phaseNr}
                                        extraClassFormGroup="col-sm-6"
                                        value={distanceReceiverCleanAsphaltKm}
                                        meta={this.props.distanceReceiverCleanAsphaltKmMeta}
                                        min={0} />
    
    
                        {/*<NumberInput    htmlName="distanceReceiverPollutedAsphaltKm"*/}
                                        {/*onChange={onChange}*/}
                                        {/*onBlur={onBlur}*/}
                                        {/*onUnmount={onUnmount}*/}
                                        {/*labelText="Avstånd till mottagare av förorenad asfalt (km)"*/}
                                        {/*extraClassFormGroup="col-sm-6"*/}
                                        {/*value={distanceReceiverPollutedAsphaltKm}*/}
                                        {/*meta={this.props.distanceReceiverPollutedAsphaltKmMeta}*/}
                                        {/*min={0} />*/}
                    </div> }
    
                    <div className="row new-material">
                        <NumberInput    htmlName="distanceFillingKm"
                                        onChange={onChange}
                                        onBlur={onBlur}
                                        onUnmount={onUnmount}
                                        labelText="Avstånd till upplag av fyllnadsmassor (km)"
                                        phaseNr={this.props.phaseNr}
                                        extraClassFormGroup="col-sm-6"
                                        value={distanceFillingKm}
                                        meta={this.props.distanceFillingKmMeta}
                                        min={0} />
    
                        <NumberInput    htmlName="distanceAsphaltKm"
                                        onChange={onChange}
                                        onBlur={onBlur}
                                        onUnmount={onUnmount}
                                        labelText="Avstånd till upplag av asfalt (km)"
                                        phaseNr={this.props.phaseNr}
                                        extraClassFormGroup="col-sm-6"
                                        value={this.props.distanceAsphaltKm}
                                        meta={this.props.distanceAsphaltKmMeta}
                                        disabled={true}
                                        min={0} />
                    </div>
                </div>

            </div>
        );

    }

}

export default ReactAI.withTracking(CalculationDistancesInput); 



// WEBPACK FOOTER //
// ./src/components/CalculationDistancesInput.js